// @ts-ignore
import React from "react";

import { useIntl } from "react-intl";

import ThreeAlternatingImageText from "@/patterns/three-alternating-image-text/src/three-alternating-image-text";

const SideBySideAlternatingImageAndTextSectionPaidLpJswFeatures = () => {
    const intl = useIntl();
    const firstImageTextSideSectionObject = {
        imageSrc:
            "https://wac.stg.internal.atlassian.com/dam/jcr:e966255e-69d5-400f-a45c-dec5442225b1/JSW_Boards.png?cdnVersion=ecc",
        headerText: intl.formatMessage({
            id: "JiraSoftwarePagePaidLpJswFeatures.jiraBoardsSideBySideImageTextSide.headerText",
            defaultMessage: "Customize how your team’s work flows"
        }),
        bodyText: intl.formatMessage({
            id: "JiraSoftwarePagePaidLpJswFeatures.jiraBoardsSideBySideImageTextSide.bodyText",
            defaultMessage:
                "Set up, clean up, and automate even the most complicated project workflows."
        }),
        imageAltText: intl.formatMessage({
            id: "JiraSoftwarePagePaidLpJswFeatures.jiraBoardsSideBySideImageTextSide.imageAltText",
            defaultMessage: "Jira boards"
        })
    };
    const secondImageTextSideSectionObject = {
        imageSrc:
            "https://wac.stg.internal.atlassian.com/dam/jcr:a02f3341-a4cc-4d40-92d0-e7d6eef5efe4/roadmaps_1462x860.png?cdnVersion=ecc",
        headerText: intl.formatMessage({
            id: "JiraSoftwarePagePaidLpJswFeatures.jiraTimelineViewSideBySideImageTextSide.headerText",
            defaultMessage: "Stay on track – even when the track changes"
        }),
        bodyText: intl.formatMessage({
            id: "JiraSoftwarePagePaidLpJswFeatures.jiraTimelineViewSideBySideImageTextSide.bodyText",
            defaultMessage:
                "Use the timeline view to map out the big picture, communicate updates to stakeholders, and ensure your team stays on the same page."
        }),
        imageAltText: intl.formatMessage({
            id: "JiraSoftwarePagePaidLpJswFeatures.jiraTimelineViewSideBySideImageTextSide.imageAltText",
            defaultMessage: "Jira timeline view."
        })
    };
    const thirdImageTextSideSectionObject = {
        imageSrc:
            "https://wac.stg.internal.atlassian.com/dam/jcr:ee041172-56ca-478b-aa45-f5cda74bc8f2/JSW_Bye%20Bye%20Spreadseets.png?cdnVersion=ecc",
        headerText: intl.formatMessage({
            id: "JiraSoftwarePagePaidLpJswFeatures.spreadsheetsSideBySideImageTextSide.headerText",
            defaultMessage: "Bye-bye, spreadsheets"
        }),
        bodyText: intl.formatMessage({
            id: "JiraSoftwarePagePaidLpJswFeatures.spreadsheetsSideBySideImageTextSide.bodyText",
            defaultMessage:
                "Keep every detail of a project centralized in real time so up-to-date info can flow freely across people, teams, and tools."
        }),
        imageAltText: intl.formatMessage({
            id: "JiraSoftwarePagePaidLpJswFeatures.spreadsheetsSideBySideImageTextSide.imageAltText",
            defaultMessage: "Spreadsheets"
        })
    };

    return (
        <ThreeAlternatingImageText
            backgroundImage={
                "linear-gradient(225deg, #deebff 0%, #ffffff 100%)"
            }
            horizontalRuleColor={"#b2d4ff"}
            imageWidth={"100%"}
            //Row 1
            imageTextSideRowOnePaddingBelowLargeScreen={"32px 0 16px"}
            rowOneHeader={firstImageTextSideSectionObject.headerText}
            rowOneBody={firstImageTextSideSectionObject.bodyText}
            rowOneImageLink={firstImageTextSideSectionObject.imageSrc}
            rowOneImageAltText={firstImageTextSideSectionObject.imageAltText}
            //Row 2
            imageTextSideRowTwoPadding={"16px 0"}
            rowTwoHeader={secondImageTextSideSectionObject.headerText}
            rowTwoBody={secondImageTextSideSectionObject.bodyText}
            rowTwoImageLink={secondImageTextSideSectionObject.imageSrc}
            rowTwoImageAltText={secondImageTextSideSectionObject.imageAltText}
            //Row 3
            imageTextSideRowThreePaddingBelowLargeScreen={"16px 0 32px"}
            rowThreeHeader={thirdImageTextSideSectionObject.headerText}
            rowThreeBody={thirdImageTextSideSectionObject.bodyText}
            rowThreeImageLink={thirdImageTextSideSectionObject.imageSrc}
            rowThreeImageAltText={thirdImageTextSideSectionObject.imageAltText}
        />
    );
};

export default SideBySideAlternatingImageAndTextSectionPaidLpJswFeatures;
